import DraggableResizableBox from "../components/base/components/DraggableResizableBox.vue";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("DraggableResizableBox", DraggableResizableBox);
});
